<template>
  <div class="contents search">
    <div class="search-result">
      <div class="layout">
        <div class="title-wrap">
          <h2 class="section-title">
            통합 검색
          </h2>
        </div>
        <div class="search-panel">
          <div class="input-search">
            <input
                type="text"
                v-model="inputQuery"
                @keydown.enter="runSearch"
                placeholder="무엇을 찾고 계신가요?"
            />
            <button type="button" @click="runSearch">
              <img src="@/assets/images/icon/ico_search_b2.svg" alt="검색">
            </button>
          </div>
          <h4>총 <strong>{{ totalCount }}건</strong>의 검색 결과를 찾았습니다.</h4>
        </div>
        <div class="result-cont">
          <!-- 검색 결과 없을 때 -->
          <!-- <div class="empty-wrap">
              <img src="@/assets/images/icon/ico_search_g.svg" alt="">
              <p>검색된 내용이 없습니다.<br>다른 검색어를 입력해주세요.</p>
          </div> -->
          <SearchSection title="ART & ARTIST" :section-total="totalByKey['ART & ARTIST'] || 0">
            <SearchArtistPage :query="searchQuery" @update:totalElements="handleUpdateTotal"
                              title="ARTIST" index-name="ARTIST" router-name="ArtistDetail"/>
            <SearchArtworkPage :query="searchQuery" @update:totalElements="handleUpdateTotal"
                               title="ARTWORK" index-name="ARTIST_ARTWORK" router-name="ArtistDetail"/>
          </SearchSection>

          <SearchSection title="ARTICLE" :section-total="totalByKey['ARTICLE'] || 0">

            <SearchArticlePage :query="searchQuery" @update:totalElements="handleUpdateTotal"
                               title="SPECIAL" index-name="ARTICLE_SPECIAL" router-name="SpecialDetail"/>
            <SearchArticlePage :query="searchQuery" @update:totalElements="handleUpdateTotal"
                               title="EXHIBITION" index-name="ARTICLE_EXHIBITION" router-name="ExhibitionDetail"/>
            <SearchArticlePage :query="searchQuery" @update:totalElements="handleUpdateTotal"
                               title="EVENT" index-name="ARTICLE_EVENT" router-name="EventDetail"/>
            <SearchArticlePage :query="searchQuery" @update:totalElements="handleUpdateTotal"
                               title="NEWS" index-name="ARTICLE_NEWS" router-name="NewsDetail"/>
          </SearchSection>


        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SearchArtistPage from "@/views/search/components/SearchArtistPage.vue";
import {onMounted, ref} from "vue";
import SearchArtworkPage from "@/views/search/components/SearchArtworkPage.vue";
import SearchArticlePage from "@/views/search/components/SearchArticlePage.vue";
import {apiClient} from "@/services/auth-header";
import SearchSection from "@/views/search/components/SearchSection.vue";
import {useUiStore} from "@/store/useUiStore";

const uiStore = useUiStore();
const inputQuery = ref('');
const searchQuery = ref('');

const runSearch = async () => {
  if(!await healthCheck()) {
    return;
  }
  searchQuery.value = encodeURIComponent(inputQuery.value);
  sumCount = 0;
  totalByKey.value = {};
}

const totalCount = ref(0);
const totalByKey = ref({})
let sumCount = 0;

const handleUpdateTotal = ({ key, value }) => {
  const current = totalByKey.value[key] || 0
  totalByKey.value[key] = current + value

  sumCount += value;
  totalCount.value = sumCount;
}

const healthCheck = async () => {
  uiStore.showLoading()
  try {
    const response = await apiClient.get(`/v1/health/elasticsearch`);
    if (response.data === 'RED') {
      alert("현재 통합검색 서비스를 점검 중입니다.");
      return false;
    } else {
      return true;
    }

  } catch (error) {
    console.error("Error fetching result data:", error);
  } finally {
    uiStore.hideLoading();
  }
};

onMounted(async () => {
  await healthCheck();
});

</script>

<style scoped>

</style>